(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection === null) {
        return;
    }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + 4;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            const recs = container.querySelectorAll('.column-block');
            const finalRecs = [];
            for (let i = 0; i < recs.length; i += 1) {
                if (finalRecs.length >= 4) 
                    break;
                

                const rec = recs[i];
                const title = rec.querySelector('.product-title').textContent;
                if (title.includes('Transaction')) 
                    continue;
                

                finalRecs.push(rec);
            }

            const dummy = document.createElement('div')
            for (let i = 0; i < finalRecs.length; i += 1) {
                const finalRec = finalRecs[i];
                dummy.appendChild(finalRec);
            }

            container.querySelector('.row.expanded.small-up-2.medium-up-4').innerHTML = dummy.innerHTML;
            productRecommendationsSection.parentElement.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        }
    };

    request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function (event) {
    if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
    }
});

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();


  } catch(e) { console.error(e); }
})();
})();
